import { reactive } from 'vue';
import type { Ata } from '../types';

type AtaTableInvoicingOkStoreAction = { type: 'reset'; payload: Ata[] };

export const createAtaTableInvoicingOkStore = (initialAtas: Ata[]) => {
  const atas = reactive<Ata[]>([...initialAtas]);

  const dispatch = (action: AtaTableInvoicingOkStoreAction): void => {
    switch (action.type) {
      case 'reset':
        atas.splice(0, atas.length, ...action.payload);
        break;
    }
  };

  return { atas, dispatch };
};
